module.exports = __webpack_public_path__ + "static/media/105.e6ecb3c4.png";